<nav class="navbar navbar-expand-lg navbar-secondary bg-secondary flex-column align-items-start"
  *ngIf="(filterForm && filters.length > 0) || this.showRefreshButton">
  <div class="mb-1" *ngIf="this.showRefreshButton">
    <button type="button" class="btn btn-outline-primary mr-1 bg-white" (click)="refresh()"><i
        class="fa fa-refresh"></i>&nbsp;Refrescar</button>
  </div>
  <div *ngIf="filterForm && (filters.length > 0 || groupedFilters.length > 0)">
    <form class="form-horizontal" id="filterForm" [formGroup]="filterForm" (keydown.enter)="filterAction()" novalidate>
      <div *ngIf="!isGroupedFilters">
        <div class="form-group row">
          <div class="form-group ml-3" *ngIf="filters.length > 0">
            <div>
              <button type="button" class="btn btn-outline-primary bg-white" (click)="clearFilters()"><i
                  class="fa fa-trash"></i>&nbsp;Limpiar Filtros</button>
            </div>
          </div>
          <div *ngFor="let filter of filters;trackBy:trackByIndex">
            <div class="form-group col" *ngIf="(filter.type == 'text')">
              <input type="text" [formControlName]="filter.code" class="form-control" [id]="filter.code"
                [name]="filter.code" [placeholder]="filter.description" (keydown.enter)="filterAction()" />
            </div>
            <div class="input-group col" *ngIf="(filter.type == 'modal')">
              <input type="text" [formControlName]="filter.code" class="form-control" [id]="filter.code"
                [name]="filter.code" [placeholder]="filter.description" (keydown.enter)="filterAction()" />
              <div class="input-group-append">
                <button class="btn btn-outline-primary mr-1 bg-white" type="button" (click)="showModal(filter)"><i
                    class="fa fa-search"></i>&nbsp;</button>
              </div>
            </div>
            <div class="form-group col" *ngIf="(filter.type == 'combobox')">
              <select [formControlName]="filter.code" class="form-control" [id]="filter.code" [name]="filter.code"
                (change)="filterAction(undefined,filter,$event)">
                <option value="">{{filter.description}}</option>
                <option *ngFor="let cb of filter.comboBoxFilterKeys" [value]="cb">
                  {{filter.comboBoxFilterValues.get(cb)}}
                </option>
              </select>
            </div>
            <div class="form-group col" *ngIf="(filter.type == 'date')">
              <input class="form-control" [id]="filter.code" [name]="filter.code" [formControlName]="filter.code"
                [popover]="filter.description" placement="top" type="date" triggers="mouseenter:mouseleave"
                placeholder="date" (change)="filterAction()">
            </div>
            <div class="form-group col" *ngIf="(filter.type == 'switch')">
              <div class="row">
                <label class="switch switch-sm switch-3d switch-light col-form-label">
                  <input type="checkbox" class="form-control switch-input" [formControlName]="filter.code"
                    (change)="filterAction()">
                  <span class="switch-slider" data-checked="&#x2713;" data-unchecked="&#x2715;"></span>
                </label>
                <label class="col col-form-label"> {{filter.description}}</label>
              </div>
            </div>
          </div>
          <div class="ml-3">
            <button type="button" class="btn btn-outline-primary mr-1 bg-white" (click)="refresh()"><i
                class="fa fa-search"></i>&nbsp;Buscar</button>
          </div>
        </div>
      </div>
      <div *ngIf="isGroupedFilters">
        <div class="form-group row">
          <div class="form-group ml-3" *ngIf="groupedFilters.length > 0">
            <div>
              <button type="button" class="btn btn-outline-primary bg-white" (click)="clearFilters()"><i
                  class="fa fa-trash"></i>&nbsp;Limpiar Filtros</button>
            </div>
          </div>
          <div *ngFor="let groupedFilter of groupedFilters;trackBy:trackByIndex" class="form-group ml-3">
            <ng-template #popTemplateHtml>
              <div>
                <div *ngFor="let filter of groupedFilter.filters;trackBy:trackByIndex" class="form-group row">
                  <div class="form-group col" *ngIf="(filter.type == 'text')">
                    <input type="text" [formControlName]="filter.code" class="form-control" [id]="filter.code"
                      [name]="filter.code" [placeholder]="filter.description" (keydown.enter)="filterAction()" />
                  </div>
                  <div class="form-group col" *ngIf="(filter.type == 'combobox')">
                    <select [formControlName]="filter.code" class="form-control" [id]="filter.code" [name]="filter.code"
                      (change)="filterAction(undefined,filter,$event)">
                      <option value="">{{filter.description}}</option>
                      <option *ngFor="let cb of filter.comboBoxFilterKeys" [value]="cb">
                        {{filter.comboBoxFilterValues.get(cb)}}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col" *ngIf="(filter.type == 'date')">
                    <input class="form-control" [id]="filter.code" [name]="filter.code" [formControlName]="filter.code"
                      [popover]="filter.description" placement="top" type="date" triggers="mouseenter:mouseleave"
                      placeholder="date" (change)="filterAction()">
                  </div>
                  <div class="form-group col" *ngIf="(filter.type == 'switch')">
                    <div class="row">
                      <label class="switch switch-sm switch-3d switch-light col-form-label">
                        <input type="checkbox" class="form-control switch-input" [formControlName]="filter.code"
                          (change)="filterAction()">
                        <span class="switch-slider" data-checked="&#x2713;" data-unchecked="&#x2715;"></span>
                      </label>
                      <label class="col col-form-label"> {{filter.description}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <button type="button" class="btn btn-outline-primary bg-white" [popover]="popTemplateHtml"
              [popoverTitle]="groupedFilter.description" placement="auto" triggers="" #pop="bs-popover"
              (click)="hideOtherPopovers(pop)" (mouseover)="addToHide(pop)">
              {{groupedFilter.description}}
            </button>
          </div>
          <div class="ml-3">
            <button type="button" class="btn btn-outline-primary mr-1 bg-white" (click)="refresh()"><i
                class="fa fa-search"></i>&nbsp;Buscar</button>
          </div>
        </div>
      </div>
    </form>

  </div>
</nav>
<form *ngIf="tableForm && headers.length > 0" [formGroup]="tableForm" novalidate [id]="tableFormId" [name]="tableFormId"
  (ngSubmit)="tableForm.valid ? onSubmit() : onSubmitWithError()"
  (change)="tableForm.valid ? onSubmit() : onSubmitWithError()">
  <table class="table table-responsive-sm table-hover table-outline mb-0 table-sm">
    <thead class="thead-light">
      <tr>
        <th *ngFor="let header of headers | hiddenFilter:{}"
          [ngClass]="{'text-center ':true, 'small-number-input': header.type=='number'}">
          <i *ngIf="header.isIcon" [ngClass]="header.iconClass"></i>
          <div *ngIf="!header.isIcon && !header.selectedAllSwitch">{{header.description}}</div>
          <div *ngIf="header.selectedAllSwitch">
            <label class="switch switch-sm switch-3d switch-primary col-form-label">
              <input type="checkbox" class="form-control switch-input"
                [formControlName]="header.code+'-selectedAllSwitch'" (change)="selecteAllSwitch(header)">
              <span class="switch-slider" data-checked="&#x2713;" data-unchecked="&#x2715;"></span>
            </label>
            <!-- (change)="selecteAllSwitch(header)" -->
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="data.content.length == 0" class="text-center">
        <td [colSpan]="headers.length.toString()">
          <h6>No hay datos.</h6>

        </td>
      </tr>
      <tr *ngFor="let item of data.content; let itemIndex = index" (click)="rowFn(item, itemIndex)"
        [ngClass]="{'tr-active':currentIndex == itemIndex && !disableHighlight,'table-success': getSuccessValue(item),'table-danger':getDangerValue(item)}">
        <td *ngFor="let header of headers | hiddenFilter; let headerIndex = index;trackBy:trackByValue.bind(this,item)"
          class="text-center" (click)="header.cellFn(item)" data-toggle="popover" [title]="header.cellTooltip"
          placement="left">
          <div *ngIf="(header.type == 'hidden')">
            <input type="hidden" [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
              [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex">
          </div>
          <div *ngIf="!header.editable">
            <div *ngIf="(header.type == 'text')">
              <small *ngIf="header.isSmall">{{getRowData(item, header)}}</small>
              <div id="itemText" *ngIf="!header.isSmall"
                [ngClass]="{'d-inline-block text-truncate max-250':header.wordWrap}">{{getRowData(item, header)}}
                {{header.secondText}}</div>
            </div>
            <div *ngIf="(header.type == 'number')"><b>{{getRowData(item, header) | number : '1.2-2'}}</b></div>
            <div *ngIf="(header.type == 'currency')">
              <b>{{getRowData(item, header) | currency: getCurrencyField(item, header):'symbol' : '1.2-2'}}</b>
            </div>
            <div *ngIf="(header.type == 'date')"> {{getRowData(item, header) | date:header.dateFormat}}</div>
            <span id="badgeText" *ngIf="header.type == 'badge'" [ngClass]="obtainBadgeClass(header, item)">
              {{getRowData(item, header)}}
            </span>
            <div class="row-sm d-flex">
              <div *ngFor="let action of header.actions">
                <!-- Acción tipo Popover -->
                <ng-container *ngIf="action.isPopOver">
                  <ng-template #popoverTemplateRef>
                    <ng-container
                      *ngTemplateOutlet="action.popOverTemplate; context: { $implicit: item }"></ng-container>
                  </ng-template>
                  <div class="col-sm p-0">
                    <button type="button" [name]="'popoverAction'+item[header.code]"
                      class="btn btn-sm btn-pill btn-light text-primary" [popover]="popoverTemplateRef"
                      [outsideClick]="true" [placement]="action.popOverPlacement || 'auto'"
                      [triggers]="action.triggers || 'click'" (click)="action.fn(item)" #pop="bs-popover">
                      <i [ngClass]="action.icon + ' fa-1x'"></i>
                    </button>
                  </div>
                </ng-container>

                <div class="col-sm p-0" *ngIf="!action.isPopOver && !action.isPrivileged">
                  <button *ngIf="(header.type == 'action')" type="button" [name]="'action'+item[header.code]"
                    [ngClass]="{'btn btn-sm btn-pill btn-light':true, 'text-primary': action.disabledFn ? !action.disabledFn(item) : true, 'text-secondary' : action.disabledFn ? action.disabledFn(item) : false}"
                    (click)="doActionfn(action,item)" data-toggle="popover" [title]="action.tooltip" placement="left"
                    [disabled]="action.disabledFn ? action.disabledFn(item) : false">
                    <i [ngClass]="action.icon+' fa-1x'"></i>
                  </button>
                </div>
                <div class="col-sm p-0" *ngIf="!action.isPopOver && action.isPrivileged">
                  <button *ngIf="(header.type == 'action')" type="button" [name]="'action'+item[header.code]"
                    [ngClass]="{'btn btn-sm btn-pill btn-light':true, 'text-primary': action.disabledFn ? !action.disabledFn(item) : true, 'text-secondary' : action.disabledFn ? action.disabledFn(item) : false}"
                    (click)="doPrivilegedAction(action,item)" data-toggle="popover" [title]="action.tooltip"
                    placement="left" [disabled]="action.disabledFn ? action.disabledFn(item) : false">
                    <i [ngClass]="action.icon+' fa-1x'"></i>
                  </button>
                </div>
              </div>
            </div>

            <label class="switch switch-sm switch-3d switch-primary" *ngIf="header.type == 'switch'">
              <input type="checkbox" class="switch-input" [checked]="getRowData(item, header)" disabled>
              <span class="switch-slider" data-checked="&#x2713;" data-unchecked="&#x2715;"></span>
            </label>
          </div>
          <div *ngIf="header.editable">
            <div *ngIf="(header.type == 'text')">
              <input class="form-control" type="text" [placeholder]="header.description"
                [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex"
                (blur)="header.cellFn(item)"
                [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid" />
            </div>
            <div *ngIf="(header.type == 'number')">
              <div class="row">
                <div class="col">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <button type="button" class="btn btn-outline-primary bg-white"
                        (click)="minusNumber(item, header,itemIndex,headerIndex)" [disabled]="!tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.enabled"><i class="fa fa-minus"></i></button>
                    </span>
                    <input class="form-control" type="number" [placeholder]="header.description"
                      [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                      [id]="header.code+'-'+itemIndex+'-'+headerIndex"
                      [name]="header.code+'-'+itemIndex+'-'+headerIndex" (blur)="header.cellFn(item)"
                      [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid" />
                    <span class="input-group-append">
                      <button type="button" class="btn btn-outline-primary bg-white"
                        (click)="plusNumber(item, header, itemIndex,headerIndex)" [disabled]="!tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.enabled"><i class="fa fa-plus"></i></button>
                    </span>
                  </div>
                </div>


              </div>
            </div>
            <div *ngIf="(header.type == 'badge') && !header.isSelfComboBoxDataSource">
              <select class="form-control" [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex"
                [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid"
                (change)="header.cellFn(item)">
                <option value="">{{header.description}}</option>
                <option *ngFor="let val of header.valueMapKeys" [value]="val">{{header.valueMap.get(val)}}
                </option>
              </select>
            </div>
            <div *ngIf="header.isSelfComboBoxDataSource">
              <select class="form-control" [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex"
                [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid"
                (change)="header.cellFn(item)">
                <option value="">{{header.description}}</option>
                <!-- TODO: falta agregar logica para mostrar el label del combo  -->
                <option *ngFor="let key of getKeyListFromMap(item.dataSourceComboBox.keys())" [value]="key">
                  {{item.dataSourceComboBox.get(key)}}
                </option>
              </select>
            </div>
            <div *ngIf="(header.type == 'date')">
              <input class="form-control" [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex"
                type="date" dateFormat="yyyy-MM-dd"
                [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid"
                placeholder="date" (change)="header.cellFn(item)">
            </div>
            <div *ngIf="(header.type == 'switch')">
              <label class="switch switch-sm switch-3d switch-primary col-form-label">
                <input type="checkbox" class="form-control switch-input"
                  [formControlName]="header.code+'-'+itemIndex+'-'+headerIndex"
                  [id]="header.code+'-'+itemIndex+'-'+headerIndex" [name]="header.code+'-'+itemIndex+'-'+headerIndex"
                  [class.is-invalid]="(tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.touched || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.dirty || tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.pristine) && tableForm.get(header.code+'-'+itemIndex+'-'+headerIndex)?.invalid"
                  (change)="switchFn(header,item)">
                <span class="switch-slider" data-checked="&#x2713;" data-unchecked="&#x2715;"></span>
              </label>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</form>
<div class="pagination ml-2" *ngIf="pagination">
  <pagination [totalItems]="data.totalElements" [(ngModel)]="currentPage" [maxSize]="5" class="pagination-sm"
    previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;" [boundaryLinks]="true"
    [rotate]="false" [itemsPerPage]="data.size" (pageChanged)="pageSelected($event)">
  </pagination>
</div>